import { render } from "./modal.vue?vue&type=template&id=d9bf38f4&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=d9bf38f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9bf38f4"

export default script